import { env } from "@/config/env";
import { messages } from "@/shared/i18n";

/**
 * Login-page privacy acceptance notice.
 *
 * Shown above the reCAPTCHA attribution when configured via `VITE_ORG_SPECIFIC_CONTENTS`.
 */
export function PrivacyPolicyLoginNotice() {
  const { privacyPolicyUrl } = env;
  if (!privacyPolicyUrl) {
    return null;
  }

  return (
    <p className="mb-3 text-center text-xs leading-relaxed text-pretty text-gray-400">
      {messages.login.page.acceptPrivacyOnLoginPrefix}{" "}
      <a
        className="text-gray-500 underline hover:text-gray-700"
        data-testid="link-login-privacy-policy"
        href={privacyPolicyUrl}
        rel="noopener noreferrer"
        target="_blank"
      >
        {messages.login.page.acceptPrivacyOnLoginLink}
      </a>
      .
    </p>
  );
}
